import { Dialog } from '@cw-ui/feedback-components';
import { Button } from '@cw-ui/form-components';
import DialogActions from '@mui/material/DialogActions';
import Locale from 'src/i18n';
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';

import { formatMessage } from 'src/i18n/intl';

import React, { useEffect } from 'react';

const universityLink =
    'https://docs.connectwise.com/ConnectWise/Asio/Getting_Started_in_the_Asio_Platform#:~:text=Prerequisite%3A%20Configure%20browser%2C%20cookies%2C%20and%20firewall%20settings';

const ThirdPartyCookiesBlockedStatusModal = () => {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        setOpen(true);
    }, []);

    const learnHowClickHandler = () => {
        window.open(universityLink, '_blank');
    };

    const mayBeLaterClickHandler = () => {
        window.history.back();
        // window.location = document.referrer;
    };

    return (
        <Dialog
            open={open}
            id="third-party-cookie-blocked-status-modal"
            data-testid="third-party-cookie-blocked-status-modal">
            <Dialog.Title sx={{ padding: 3 }}>{formatMessage(Locale.thirdPartyCookiesBlockedPopupTitle)}</Dialog.Title>
            <Dialog.DialogContent sx={{ textAlign: 'center', padding: 8 }}>
                <CookieOutlinedIcon sx={{ fontSize: '7rem', marginBottom: 2, color: 'text.textSecondary' }} />
                <Dialog.DialogContentText variant="body1" sx={{ color: 'text.textSecondary' }}>
                    {formatMessage(Locale.thirdPartyCookiesBlockedPopupMsg)}
                </Dialog.DialogContentText>
            </Dialog.DialogContent>
            <DialogActions sx={{ padding: 3, gap: 2, justifyContent: 'space-between' }}>
                <Button
                    variant="outlined"
                    color="secondary"
                    data-testid="maybe-later-button"
                    onClick={mayBeLaterClickHandler}>
                    {formatMessage(Locale.mayBeLater)}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    data-testid="learn-how-button"
                    onClick={learnHowClickHandler}>
                    {formatMessage(Locale.learnHow)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default ThirdPartyCookiesBlockedStatusModal;
